import React from "react";
import { AddAction } from "components/buttons";
import { Restricted, permissions } from "components/auth";

const ActionButtons = () => (
  <Restricted permissions={[permissions.deployment_manage]}>
    <AddAction url={`/deployment/new`} />
  </Restricted>
);

export default ActionButtons;
